import Reveal from "@/components/site/Reveal";
import { useT } from "@/i18n";

export default function HistorySection() {
  const t = useT();
  return (
    <section className="bg-[#F5F5F5] text-black py-24 md:py-32" data-testid="history-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <Reveal className="max-w-3xl mb-20">
          <p className="text-xs uppercase tracking-[0.4em] text-[#C20E1A] font-bold">
            {t.history.eyebrow}
          </p>
          <h2 className="heading-display mt-4 text-5xl sm:text-6xl lg:text-7xl uppercase text-black">
            {t.history.title1} <span className="text-[#C20E1A]">{t.history.title2}</span>
          </h2>
          <p className="mt-8 text-lg text-black leading-relaxed">{t.history.intro}</p>
        </Reveal>

        <div className="relative">
          <div className="absolute left-3 md:left-1/2 top-0 bottom-0 w-px bg-black/15" />
          <div className="space-y-16">
            {t.history.items.map((m, i) => (
              <Reveal
                key={m.year}
                className={`relative md:grid md:grid-cols-2 md:gap-16 ${
                  i % 2 === 0 ? "" : "md:[&>*:first-child]:order-2"
                }`}
                delay={i * 60}
              >
                <div
                  className={`pl-12 md:pl-0 ${
                    i % 2 === 0 ? "md:text-right md:pr-16" : "md:text-left md:pl-16"
                  }`}
                >
                  <p className="text-5xl lg:text-6xl font-bold italic text-[#C20E1A] tracking-tight">
                    {m.year}
                  </p>
                  <h3 className="mt-3 text-xl lg:text-2xl uppercase font-bold tracking-tight text-[#C20E1A]">
                    {m.title}
                  </h3>
                </div>
                <div className={`pl-12 md:pl-0 mt-4 md:mt-0 ${i % 2 === 0 ? "md:pl-16" : "md:pr-16"}`}>
                  <p className="text-base text-black leading-relaxed">{m.body}</p>
                </div>
                {/* node */}
                <span className="absolute left-2 md:left-1/2 top-2 md:top-3 -translate-x-1/2 h-3 w-3 rounded-full bg-[#C20E1A] ring-4 ring-[#F5F5F5]" />
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-20 max-w-3xl mx-auto text-center" delay={120}>
            <p className="text-xs uppercase tracking-[0.4em] text-[#C20E1A] font-bold">
              {t.history.futureEyebrow}
            </p>
            <p className="mt-4 text-base text-black leading-relaxed">{t.history.futureBody}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
